// extracted by mini-css-extract-plugin
export default {"container":"statusImage_container__P2YfT","ok":"statusImage_ok__wKgvP","info":"statusImage_info__OIf1o","redirect":"statusImage_redirect__2XNKf","error":"statusImage_error__1ivOR"};